import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { colors, darken } from '@mui/material';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import React from 'react';
export function RatingStars({ rating, ...props }) {
    return React.createElement(RatingStarsStyle, { ...props, readOnly: true, max: 3, precision: 1, value: ratingStars(rating ?? 0), emptyIcon: React.createElement(StarBorderIcon, { fontSize: "inherit" }), icon: React.createElement(StarIcon, { fontSize: "inherit" }) });
}
const RatingStarsStyle = styled(Rating, {
    slot: 'Root',
    name: 'RatingStars'
})(({ theme }) => ({
    '& .MuiRating-iconEmpty': {
        color: darken(theme.palette.divider, 0.5),
    },
    '& .MuiRating-iconFilled': {
        color: colors.amber['A400'],
    }
}));
function ratingStars(rating) {
    return rating < 0.7 ? 0
        : rating < 0.8 ? 1
            : rating < 0.9 ? 2
                : 3;
}
//# sourceMappingURL=RatingStars.js.map